const readImageDimensions = (file: File): Promise<[number, number]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.onload = () => {
        resolve([image.width, image.height]);
      };
      image.onerror = () => {
        reject();
      };
      image.src = reader.result as string;
    };
    reader.onerror = () => {
      reject();
    };
    reader.readAsDataURL(file);
  });
};

export default readImageDimensions;
